<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 17:14:19
 * @Description: 账号安全 生物识别（暂未使用）
-->
<template>
	<div>
		<!-- 可信设备管理 -->
		<div class="item">
			<Head title="设备管理" :iconUrl="require('@/assets/images/account/identify_manager.png')" />
			<div class="content">
				<div>
					<img src="@/assets/images/account/identify_man_icon.png" alt="" style="margin-right: 10px" />
					可信设备管理
				</div>
				<div><span>管理</span></div>
			</div>
		</div>

		<!-- 开启生物识别 -->
		<div class="item" style="margin-top: 20px">
			<Head title="开启生物识别" :iconUrl="require('@/assets/images/account/ifentify_valid_icon.png')" />
			<div class="content">
				<div>
					<img src="@/assets/images/account/identify_valid.png" alt="" style="margin-right: 10px" />
					生物验证
				</div>
				<div><JSwitch v-model="switchValue" :options="[1, 0]" /></div>
			</div>
		</div>

		<!-- 生物识别说明 -->

		<div class="identify-desc">
			<div>生物识别说明：</div>

			<div>
				<div>1. 打开生物识别按钮，若当前浏览器支持</div>
				<div>
					2. 设置成功后，使用该设备在当前浏览器登录时，登录页面增加生物识别登录方式，若切换设备或切换浏览器该功能失效。
				</div>
				<div>
					3. 若用户清理浏览器缓存，会同时清除生物识别绑定信息，可信设备管理列表绑定记录失效，用户开启生物验证需再次验证绑定该设备。
				</div>
				<div>4. 移动端用户生物识别登录设置与上述步骤相同。</div>
			</div>
		</div>
	</div>
</template>

<script>
import JSwitch from "@/components/public/form/ant/JSwitch";
import Head from "../../compontents/Head";
export default {
	components: {
		JSwitch,
		Head,
	},
	name: "identify",

	data() {
		return {
			switchValue: 1,
		};
	},
};
</script>

<style lang="less" scoped>
.head {
	.title {
		font-weight: 500;
		color: #040849;
		font-size: 16px;
		margin-left: 10px;
	}
}
.content {
	border: 1px solid #ececec;
	padding: 15px 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 18px;
	& > div:last-child {
		span {
			padding: 10px 46px;
			border: 1px solid var(--primary-color);
			background-color: var(--primary-color);
			cursor: pointer;
			color: #fff;
			border-radius: 4px;
		}
	}
}
.identify-desc {
	margin-top: 30px;
	& > div:last-child {
		margin-top: 10px;
		color: #999999;
		font-size: 14px;
		& > div {
			margin-top: 10px;
		}
	}
}
</style>
